












































































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator'

import {Product, Show} from '@/store/modules/lib'
import {ServerProduct} from '@/utils/ServerProduct'
import {ServerPicture} from '@/utils/ServerPicture'
import {Meta} from '@sophosoft/vue-meta-decorator'
import {namespace} from 'vuex-class'
import Chip from '@/components/UI/Chip.vue'
import Tooltip from '@/components/UI/Tooltip.vue';
import Search from "@/components/UI/Search.vue";
import Modal from "@/components/UI/Modal.vue";

const auth = namespace('auth')
const profile = namespace('profile')
const event = namespace('event')
const roistat = namespace('roistat')

@Component({
  components: {
    'c-chip': Chip,
    Tooltip,
    Search,
    Modal
  }
})
export default class ProductList extends Vue {
  @Meta
  getMetaInfo() {
    return {
      title: `LeadFrog - ${this.$t('products.title')}`
    }
  }

  @auth.State('exhibitorId') protected _exhibitor: any
  @auth.Getter('showId') protected showId: any
  @event.Getter('shows') protected shows: any
  @profile.State('standCompanies') protected standCompanies: any
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any

  @Watch('editProductDlgState')
  isEditProductDlgStateChanged(newValue: boolean) {
    if (!newValue) {
      this.editProductDlgTab = 'tab-1'
    }
  }

  @Watch('search')
  getSearch() {
    this.clickSearch
  }

  protected pageLoading: boolean = true

  protected search: string = ''

  inputEditProduct(value: Product) {
    this.editProduct = {...value}
  }

  //добавление фото
  protected fileSetting: any = {
    file: '',
    showPreview: false,
    imagePreview: ''
  }

  showPhoto(e: any) {
    this.fileSetting = e
  }

  getPhotoUrl(id: string) {
    //показ картинки
    let prod = this.products.find((item: any) => item._id == id)

    if (prod && prod.photo !== '') {
      ServerPicture.getPictureByKeys([prod.photo])
        .then((res: any) => {
          if (prod) {
            this.showPhoto({
              file: '',
              showPreview: true,
              imagePreview: res.data[prod.photo]
            })
          }
        })
    } else {
      this.showPhoto({
        file: '',
        showPreview: false,
        imagePreview: ''
      })
    }
  }

  editProductDlgClose() {
    this.editProductDlgState = false

    this.fileSetting = {
      file: '',
      showPreview: false,
      imagePreview: ''
    }
  }

  protected commonLoadState: boolean = false

  protected products: Product[] = []
  protected selectedProductId: string | null = null

  protected deleteDlgState: boolean = false
  protected removeProductId: string = ''

  protected editProductDlgState: boolean = false
  protected editProductDlgTab: string = 'tab-1'

  protected allProductsSvgDlgState: boolean = false
  protected allProductsSvgLink: string = ''
  protected allProductsSvgError: boolean = false

  // Статус отслеживающий редактирование продукта
  protected productEditState: boolean = false

  protected errorFields: string[] = []

  protected qrExampleDlg: boolean = false

  protected get showName() {
    let show: Show = this.shows.filter((s: Show) => s._id == this.showId)[0]

    return show ? show.title : ''
  }

  protected inputDlgLinks(value: Product): void {
    this.editProduct = value
  }

  protected editProduct: Product = {
    characters: [],
    _company: '',
    description: '',
    _event: '',
    _id: '',
    photo: '',
    promo: [],
    _show: '',
    standTitle: '',
    thematic: {
      title: '',
      child: [],
      id: '',
    },
    title: '',
    vendorCode: ''
  }

  protected get productDlgTitle() {
    return this.productEditState
      ? `${this.$t('products.add.editTitle')}: ${this.editProduct.title}`
      : this.$t('products.add.title')
  }

  protected get selectedProduct() {
    let items = this.products.filter(
      (product) => product._id == this.selectedProductId
    );
    return items.length > 0 ? items[0] : null;
  }

  protected get filteredProducts(): Product[] {
    const trim = this.search.trim()

    if (trim) {
      const regexp = new RegExp(trim, 'i')

      return this.products.filter(v => regexp.test(v.title))
    }

    return this.products
  }

  protected get groupProduct() {
    return this.filteredProducts.reduce((groups: any, product: any) => {
      if( !product.thematic || product.thematic === "" ){
        product.thematic= {title: ''}
      }

        if (!groups[product.thematic.title])
          groups[product.thematic.title] = [product]
        else
          groups[product.thematic.title].push(product)


      return groups
    }, {})
  }

  protected sendAllSvgFiles() {
    this.allProductsSvgLink = ''
    this.allProductsSvgError = false
    this.allProductsSvgDlgState = true

    Vue.axios({
      url: `/svgzip/${this._exhibitor}`,
      method: 'GET'
    })
      .then((resp: any) => {

        if (resp.data.code === '01') {
          this.allProductsSvgLink = resp.data.link
        } else {
          this.allProductsSvgError = true
        }
      })
      .catch((err: any) => {
        this.allProductsSvgError = true
      })
  }


  protected selectProduct(id: string) {
    this.selectedProductId = id
    this.products = this.products.map((product: Product) => {
      product.isSelect = this.selectedProductId == product._id
      return product
    })

    this.getPhotoUrl(id)
  }

  protected openDlgNewProduct() {
    this.fileSetting = {
      file: '',
      showPreview: false,
      imagePreview: ''
    }

    this.clearEditProduct()
    this.errorFields = []
    this.editProduct._company = this.standCompanies[0]._id
    this.productEditState = false
    this.editProductDlgState = true
  }

  protected openDlgEditProduct(editId: string) {
    const product = this.products.find((product: Product) => product._id == editId)

    if (product) {
      this.editProduct = {...product}
      this.errorFields = []
      this.productEditState = true
      this.editProductDlgState = true
    }

    this.getPhotoUrl(editId)
  }

  protected validateDlgValues() {
    this.errorFields = [];
    if (
      this.editProduct.title.trim() === '' ||
      this.editProduct.title.length > 75
    )
      this.errorFields.push('title')

    if (this.editProduct.vendorCode.length > 20)
      this.errorFields.push('vendorCode')

    // if (this.editProduct.thematic.title.trim() === '')
    //   this.errorFields.push('thematic')

    if (this.editProduct.description.length > 400)
      this.errorFields.push('description')

    return this.errorFields.length === 0
  }

  protected writeProduct(): void {
    if (this.validateDlgValues()) {
      if (this.productEditState) {
        this.updateProduct()
      } else {
        this.createProduct()
      }

      this.editProductDlgState = false
      let params = [
        {
          "name": this.productEditState ? "“Продукция”: Переход в “Редактирование продукции”, измененния сохранены" : "“Продукция”: Переход в “Добавление продукции”, сохранено",
          "data": {
            "company": this.userCompany.title
          }
        }
      ]
      this.sendEvent(params)
    }
  }

  protected uploadPicture() {
    return new Promise((resolve: any) => {
      if (this.fileSetting.file !== '' && this.fileSetting.isNew) {
        ServerPicture.uploadPicture(this.fileSetting)
          .then(res => {
            if (this.editProduct.photo !== '') {
              ServerPicture.deletePicture([this.editProduct.photo])
            }

            this.editProduct.photo = res.data.key
            resolve()
          })
      } else {
        resolve()
      }
    })
  }

  protected createProduct() {

    this.uploadPicture()
      .then(() => {
        ServerProduct.add(this.editProduct, this.editProduct._company)
          .then((product: Product) => {
            this.editProduct._id = product._id
            this.editProduct._event = product._event
            this.editProduct._show = product._show
            this.editProduct.standTitle = product.standTitle
            const c_product = this.editProduct
            this.products.push(c_product)
            this.clearEditProduct()
            this.selectProduct(product._id)

            this.editProductDlgClose()
          })
          .catch(() => {
            // this.$notifyDange('Не удалось загрузить продукты!')
          })
      })
  }

  protected updateProduct() {
    this.uploadPicture()
      .then(() => {
        ServerProduct.update(this.editProduct)
          .then((product: Product) => {
            const c_product = this.editProduct
            this.products = this.products.filter((p: Product) => p._id != c_product._id)
            this.products.push(c_product)
            this.clearEditProduct()
            this.selectProduct(product._id)
          })
          .catch(() => {
            // this.$notifyDange('Не удалось загрузить продукты!')
          })
      })
  }

  protected openDlgRemoveProduct(removeId: string) {
    this.removeProductId = removeId
    this.deleteDlgState = true
  }

  protected productRemove() {
    this.deleteDlgState = false

    let product = this.products.find(prod => prod._id == this.removeProductId)
    if (product && product.photo !== '') {
      ServerPicture.deletePicture([product.photo])
    }

    ServerProduct.remove(this.removeProductId)
      .then((isRemoved) => {
        if (isRemoved) {
          this.products = this.products.filter(
            (product: Product) => product._id !== this.removeProductId
          )
        }
        let params = [
          {
            "name": "“Продукция”: Действие “Удаление продукции”",
            "data": {
              "company": this.userCompany.title
            }
          }
        ]
        this.sendEvent(params)
      })
      .catch(() => {
        // this.$notifyDange('Не удалось загрузить продукты!')
      })
  }

  protected clearEditProduct() {
    this.editProduct = {
      characters: [],
      _company: '',
      description: '',
      _event: '',
      _id: '',
      photo: '',
      promo: [],
      _show: '',
      standTitle: '',
      thematic: {
        title: '',
        child: [],
        id: '',
      },
      title: '',
      vendorCode: ''
    }
  }

  protected mounted() {
    this.commonLoadState = false

    this.clearEditProduct()

    ServerProduct.list(this._exhibitor)
      .then((productList: Product[]) => {
        this.products = productList
        this.commonLoadState = true
        if (this.products.length === 0) this.openDlgNewProduct()
      })
      .catch(() => {
        // this.$notifyDange('Не удалось загрузить продукты!')
      })
      .finally(() => {
        this.pageLoading = false
      })
  }

  downloadFile() {
    this.allProductsSvgDlgState = false
    let params = [
      {
        "name": "“Продукция”: Действие “Скачать файлы для печати QR кода” - “Скачать файл”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  clickSearch() {
    let params = [
      {
        "name": "“Продукция”: Действие “Поиск”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }
}
